export const REDIRECTION_URLS = {
    coral: 'https://myaccount.coral.co.uk/en/mobileportal/contact?showContact=true&keyword=CP',
    ladbrokes: 'https://myaccount.ladbrokes.com/en/mobileportal/contact?showContact=true&keyword=CP',
};
